import { Select, FormControl, MenuItem, makeStyles } from "@material-ui/core";
import React from "react";
import "./MiniSelectBox.scss";
import MiniSelectBoxProps from "./MiniSelectBox.types";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: 0,
    minWidth: 120,
    width: "-webkit-fill-available",
    // height: "2rem",
  },
}));

const MiniSelectBox = (props: MiniSelectBoxProps) => {
  const classes = useStyles();
  const [value, setValue] = React.useState<any>("");
  const [open, setOpen] = React.useState(false);
  const [reset, setReset] = React.useState(false);
  const [placeHolder, setPlaceHolder] = React.useState(props.placeHolder);

  React.useEffect(() => {
    setPlaceHolder(props.placeHolder);
  }, [props.placeHolder]);

  React.useEffect(() => {
    if (props.defaultVal?.length > 0) {
      setValue(props.defaultVal);
    }
  }, [props.defaultVal]);

  React.useEffect(() => {
    if (props.resetVal) {
      setReset(true);
    }
  }, [props.resetVal]);
  React.useEffect(() => {
    if (reset) {
      setValue("");
      setReset(false);
      props.changeReset();
    }
  }, [reset]);

  const handleChange = (event: any) => {
    setValue(event.target.value);
  };

  const handleClose = (event: any) => {
    setOpen(false);
    setValue(event.target.outerText !== "" ? event.target.outerText : value);
    // setValue(event.target.outerText);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const change = (e: any) => {
    console.log(e.target.value);
    setValue(e.target.value);
    return value;
  };

  return (
    <div className="miniselectBox_wrapper">
      <div className="cover">
        <FormControl className={classes.formControl}>
          <div className="select_label">
            <label className="fw-600">{props?.label}</label>
          </div>
          <Select
            className={
              props?.borderColor === "danger"
                ? "border-danger"
                : props?.borderColor === "default"
                ? "border-default"
                : "border-primary"
            }
            labelId="demo-controlled-open-select-label"
            id="demo-controlled-open-miniselect"
            name={props.name}
            disabled={props.disabled}
            open={open}
            onClose={(e) => {
              handleClose(e);
            }}
            onOpen={handleOpen}
            onChange={props.onChange}
            value={value}
            displayEmpty
            renderValue={value !== "" ? undefined : () => props.placeHolder}
          >
            {props.data?.map((item: any, i: any) => (
              <MenuItem key={i} value={item}>
                {item}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    </div>
  );
};

// SelectBox.propTypes = {
//   onChange: PropTypes.func,
// };

export default MiniSelectBox;
